import { render, staticRenderFns } from "./SvgIcons.vue?vue&type=template&id=7c82f8a6&scoped=true"
import script from "./SvgIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcons.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SvgIcons.vue?vue&type=style&index=0&id=7c82f8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82f8a6",
  null
  
)

export default component.exports